import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=57bf6e54&scoped=true&"
import script from "./AccordionCard.vue?vue&type=script&lang=js&"
export * from "./AccordionCard.vue?vue&type=script&lang=js&"
import style0 from "./AccordionCard.vue?vue&type=style&index=0&id=57bf6e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf6e54",
  null
  
)

export default component.exports